// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 6: पौलुस के मिशन
// ============================================================================
// स्तर 66-78 (13 स्तर, 39 प्रश्न)

export const chapter6Translations = {
  name: "पौलुस के मिशन",
  description: "पृथ्वी की छोर तक...",
  
  spiritualWisdom: {
    principle: "सुसमाचार सभी राष्ट्रों के लिए है और पूरे विश्व में प्रचारित किया जाना चाहिए",
    scripture: "जाओ और सभी राष्ट्रों को शिष्य बनाओ (मत्ती 28:19)",
    application: "प्रत्येक मसीही को परमेश्वर द्वारा रखे गए स्थान पर मसीह का गवाह बनने के लिए बुलाया गया है"
  },
  
  levels: {
    66: {
      name: "प्रथम मिशनरी यात्रा",
      challenge: "बरनबास और शाऊल को मेरे लिए अलग करो, जिस काम के लिए मैंने उन्हें बुलाया है...",
      easy: {
        question: "पौलुस की पहली यात्रा में कौन साथ गया?",
        options: ["पतरस", "बरनबास", "सीलास", "तीमुथियुस"],
        hint: "'सांत्वना का पुत्र'",
        funFact: "👥 बरनबास ने धर्मांतरण के बाद पौलुस को स्वीकार किया - दैवीय साझेदारी!"
      },
      medium: {
        question: "वे किस शहर से मिशन के लिए रवाना हुए?",
        options: [
          "यरूशलेम",
          "सीरिया का अन्ताकिया",
          "तरसुस",
          "दमिश्क"
        ],
        hint: "यहूदियों और अन्यजातियों की पहली मिश्रित कलीसिया",
        funFact: "🚢 अन्ताकिया: पश्चिमी दुनिया के सुसमाचार प्रचार का प्रस्थान बंदरगाह!"
      },
      hard: {
        question: "यह पहली यात्रा मिशनरी रणनीति के बारे में क्या प्रकट करती है?",
        options: [
          "अपने क्षेत्र में रहना चाहिए",
          "सुसमाचार सभी सांस्कृतिक सीमाओं को पार करता है",
          "केवल यहूदी ही बचाए जा सकते हैं",
          "मिशन वैकल्पिक है"
        ],
        hint: "संदेश की सार्वभौमिकता के बारे में",
        funFact: "🌊 भूमध्य सागर पार करना = वैश्विक सुसमाचार प्रचार की ओर पहला कदम!"
      }
    },
    
    67: {
      name: "कुप्रुस में इलीमास के साथ",
      challenge: "सब छल और सब दुष्टता से भरे हुए, शैतान के पुत्र...",
      easy: {
        question: "कुप्रुस में पौलुस का विरोध करने वाला जादूगर कौन था?",
        options: ["शमौन", "इलीमास", "अपुल्लोस", "सिकन्दर"],
        hint: "राज्यपाल को भटकाने की कोशिश करने वाला झूठा भविष्यवक्ता",
        funFact: "🪄 सुसमाचार और जादू का पहला सीधा टकराव!"
      },
      medium: {
        question: "पौलुस ने इलीमास को दंड के रूप में क्या दिया?",
        options: [
          "उसे भगा दिया",
          "उसे अस्थायी रूप से अंधा कर दिया",
          "उसे अनदेखा कर दिया",
          "उससे बहस की"
        ],
        hint: "आध्यात्मिक आँखें खोलने के लिए अस्थायी अंधापन",
        funFact: "👁️ परमेश्वर की विडंबना: जिसने आत्माओं को अंधा किया, वह अस्थायी रूप से अंधा हो गया!"
      },
      hard: {
        question: "यह प्रसंग सुसमाचार की शक्ति को कैसे दर्शाता है?",
        options: [
          "हिंसा आवश्यक है",
          "परमेश्वर का सत्य झूठ पर विजयी होता है",
          "सभी जादूगरों से लड़ना होगा",
          "पौलुस प्रतिशोधी था"
        ],
        hint: "छल पर परमेश्वर के अधिकार के बारे में",
        funFact: "⚡ राज्यपाल ने परमेश्वर की शक्ति देखकर विश्वास किया - प्रभावी गवाही!"
      }
    },

    68: {
      name: "पिसिदिया के अन्ताकिया में",
      challenge: "परमेश्वर का वचन पहले तुम्हें सुनाया जाना चाहिए था...",
      easy: {
        question: "शहर में पहुँचने पर पौलुस पहले कहाँ प्रचार करता था?",
        options: [
          "सार्वजनिक चौक में",
          "पहले आराधनालय में",
          "धनी के घर में",
          "मूर्तिपूजक मंदिर में"
        ],
        hint: "वह हमेशा अपने लोगों से शुरू करता था",
        funFact: "🕍 मिशनरी रणनीति: पहले यहूदियों को, फिर अन्यजातियों को!"
      },
      medium: {
        question: "यहूदियों ने पौलुस के संदेश पर कैसे प्रतिक्रिया दी?",
        options: [
          "सभी ने स्वीकार किया",
          "विभाजित हो गए: कुछ ने विश्वास किया, कुछ ने विरोध किया",
          "उदासीन रहे",
          "तुरंत उसे भगा दिया"
        ],
        hint: "सुसमाचार पर विशिष्ट विभाजन",
        funFact: "⚖️ सुसमाचार हमेशा विभाजित करता है: स्वीकार या अस्वीकार, कोई उदासीनता नहीं!"
      },
      hard: {
        question: "पौलुस अन्यजातियों की ओर क्यों मुड़ता है?",
        options: [
          "उसे अन्यजातियों को प्राथमिकता थी",
          "यहूदियों की अस्वीकृति अन्यजातियों के लिए दरवाजा खोलती है",
          "यह आसान था",
          "उसने मिशन को त्याग दिया"
        ],
        hint: "भविष्यवाणी की पूर्ति के बारे में",
        funFact: "🚪 'अन्यजातियों की ज्योति' - यशायाह की भविष्यवाणी पौलुस द्वारा पूर्ण!"
      }
    },

    69: {
      name: "लुस्त्रा में चंगाई",
      challenge: "देवता मनुष्य के रूप में हमारे पास उतर आए हैं!",
      easy: {
        question: "पौलुस ने लुस्त्रा में क्या चंगाई की?",
        options: [
          "अंधा व्यक्ति",
          "जन्म से लंगड़ा व्यक्ति",
          "बहरा-गूंगा",
          "कोढ़ी"
        ],
        hint: "कभी चलने में सक्षम नहीं",
        funFact: "🦵 आश्चर्यजनक चमत्कार: 'अपने पैरों पर सीधे खड़े हो!' - चंगाई का विश्वास!"
      },
      medium: {
        question: "भीड़ ने पौलुस और बरनबास को क्या समझा?",
        options: [
          "राजा",
          "देवता (ज़्यूस और हरमेस)",
          "जादूगर",
          "भविष्यवक्ता"
        ],
        hint: "ग्रीक पौराणिक कथाओं के देवता",
        funFact: "⚡ बरनबास = ज़्यूस (गरिमामय), पौलुस = हरमेस (वाक्पटु) - सांस्कृतिक गलतफहमी!"
      },
      hard: {
        question: "पौलुस ने इस मूर्तिपूजा पर कैसे प्रतिक्रिया दी?",
        options: [
          "सम्मान स्वीकार करता है",
          "कपड़े फाड़ता है और सच्चे परमेश्वर का प्रचार करता है",
          "विनम्रता से चुप रहता है",
          "स्थिति का लाभ उठाता है"
        ],
        hint: "मूर्तिपूजा की पूर्ण अस्वीकृति",
        funFact: "👔 कपड़े फाड़ना = मूर्तिपूजा पर यहूदी भय - पूर्ण ईमानदारी!"
      }
    },

    70: {
      name: "पत्थराव और पुनरुत्थान",
      challenge: "जब शिष्यों ने उसे घेर लिया, तो वह उठकर शहर में चला गया...",
      easy: {
        question: "लुस्त्रा के निवासियों ने पौलुस के साथ क्या किया?",
        options: [
          "कैद कर दिया",
          "पत्थर मारे",
          "निर्वासित कर दिया",
          "सूली पर चढ़ा दिया"
        ],
        hint: "पारंपरिक यहूदी दंड",
        funFact: "🪨 एक दिन में 'देवता' से 'मृत' तक - मानवीय भीड़ की अस्थिरता!"
      },
      medium: {
        question: "पत्थराव के बाद पौलुस ने क्या किया?",
        options: [
          "शहर से भाग गया",
          "छिप गया",
          "उठकर शहर में लौट गया",
          "अस्पताल गया"
        ],
        hint: "मृत समझे जाने के बाद अलौकिक साहस",
        funFact: "💪 चमत्कारी पुनरुत्थान या परमेश्वर की चंगाई - अविश्वसनीय साहस!"
      },
      hard: {
        question: "यह उत्पीड़न गवाही की कीमत के बारे में क्या प्रकट करता है?",
        options: [
          "संघर्ष से बचना चाहिए",
          "मसीह के लिए गवाही देने से जीवन का बलिदान हो सकता है",
          "पौलुस लापरवाह था",
          "उत्पीड़न व्यर्थ है"
        ],
        hint: "सत्य की गवाही की कीमत के बारे में",
        funFact: "✝️ 'हमें बहुत क्लेशों से होकर परमेश्वर के राज्य में प्रवेश करना होगा' - पौलुस का यथार्थवाद!"
      }
    },

    71: {
      name: "यरूशलेम परिषद",
      challenge: "यदि तुम खतना नहीं कराओगे तो बच नहीं सकते...",
      easy: {
        question: "यरूशलेम परिषद में कौन सी महत्वपूर्ण बहस हुई?",
        options: [
          "बपतिस्मा",
          "धर्मांतरित अन्यजातियों का खतना",
          "सब्त",
          "भेंट"
        ],
        hint: "मसीही बनने के लिए यहूदी बनना आवश्यक है?",
        funFact: "✂️ पहला बड़ा संकट: मसीहियत या यहूदी-मसीहियत?"
      },
      medium: {
        question: "परिषद का अंतिम निर्णय क्या था?",
        options: [
          "खतना अनिवार्य",
          "अन्यजातियों के लिए स्वतंत्रता, कुछ सिफारिशों के साथ",
          "यहूदियों से पूर्ण अलगाव",
          "निर्णय स्थगित"
        ],
        hint: "बड़े प्रतिबंधों के बिना अन्यजातियों के लिए खुलापन",
        funFact: "🆓 ऐतिहासिक क्रांति: सुसमाचार मूसा की व्यवस्था से मुक्त!"
      },
      hard: {
        question: "यह परिषद सार्वभौमिक कलीसिया के लिए क्या महत्व रखती है?",
        options: [
          "तुच्छ घटना",
          "केवल विश्वास से उद्धार की सार्वभौमिकता स्थापित करती है",
          "कलीसिया को विभाजित करती है",
          "व्यवस्थावाद को मजबूत करती है"
        ],
        hint: "सार्वभौमिक कलीसिया की नींव के बारे में",
        funFact: "🌍 इस निर्णय के बिना मसीहियत यहूदी धर्म का एक संप्रदाय बनी रहती!"
      }
    },

    72: {
      name: "दूसरी यात्रा: तीमुथियुस",
      challenge: "पौलुस उसे साथ ले जाना चाहता था और यहूदियों के लिए उसका खतना किया...",
      easy: {
        question: "युवा सहयोगी के रूप में पौलुस के साथ कौन शामिल हुआ?",
        options: ["मरकुस", "लूका", "तीमुथियुस", "तीतुस"],
        hint: "पौलुस का 'प्रिय पुत्र'",
        funFact: "👦 तीमुथियुस: युवा प्रतिभा पौलुस का दाहिना हाथ बन गया - सफल शिष्यता!"
      },
      medium: {
        question: "प्राप्त स्वतंत्रता के बावजूद पौलुस ने तीमुथियुस का खतना क्यों किया?",
        options: [
          "कानूनी बाध्यता के कारण",
          "यहूदियों के बीच मिशनरी रणनीति के कारण",
          "परंपरा के कारण",
          "गलती से"
        ],
        hint: "बाधाओं से बचने के लिए व्यावहारिक बुद्धि",
        funFact: "🎯 बुद्धिमान स्वतंत्रता: 'मैं सब के लिए सब कुछ बना, ताकि किसी न किसी रीति से कुछ का उद्धार करूँ'!"
      },
      hard: {
        question: "यह दृष्टिकोण मिशनरी लचीलेपन को कैसे दर्शाता है?",
        options: [
          "पौलुस असंगत था",
          "उसने सुसमाचार से समझौता किए बिना विधियों को अनुकूलित किया",
          "उसने दबाव में झुक गया",
          "वह पाखंडी था"
        ],
        hint: "प्रासंगिक बुद्धि के बारे में",
        funFact: "⚖️ दृढ़ सिद्धांत, लचीली विधियाँ - प्रभावी गवाही की कला!"
      }
    },

    73: {
      name: "मकिदुनियाई का दर्शन",
      challenge: "मकिदुनिया में आकर हमारी सहायता करो!",
      easy: {
        question: "रात के दर्शन में पौलुस ने क्या देखा?",
        options: [
          "एक स्वर्गदूत",
          "एक मकिदुनियाई उसे बुला रहा है",
          "यीशु उससे बात कर रहा है",
          "एक महान प्रकाश"
        ],
        hint: "यूरोप से सहायता की पुकार",
        funFact: "🌉 निर्णायक दर्शन: सुसमाचार यूरोप में पार करता है - ऐतिहासिक मोड़!"
      },
      medium: {
        question: "सुसमाचार प्रचार प्राप्त करने वाला पहला यूरोपीय शहर कौन सा था?",
        options: [
          "एथेंस",
          "कुरिन्थुस",
          "फिलिप्पी",
          "थिस्सलुनीके"
        ],
        hint: "मकिदुनिया में रोमन उपनिवेश",
        funFact: "🏛️ फिलिप्पी: पहली यूरोपीय कलीसिया - महाद्वीप हमेशा के लिए बदल गया!"
      },
      hard: {
        question: "यह दर्शन मसीही इतिहास के लिए क्या प्रतीक है?",
        options: [
          "साधारण सपना",
          "पश्चिम की ओर दैवीय विस्तार",
          "मतिभ्रम",
          "योजना में परिवर्तन"
        ],
        hint: "इतिहास को निर्देशित करने वाले प्रावधान के बारे में",
        funFact: "🗺️ इस दर्शन के बिना यूरोप मूर्तिपूजक रह जाता - परमेश्वर की योजना!"
      }
    },

    74: {
      name: "लुदिया, पहली यूरोपीय धर्मांतरित",
      challenge: "प्रभु ने लुदिया का हृदय खोल दिया कि वह ध्यान दे...",
      easy: {
        question: "लुदिया का पेशा क्या था?",
        options: [
          "रोटी बनाने वाली",
          "बैंगनी कपड़े की व्यापारी",
          "बुनकर",
          "कुम्हार"
        ],
        hint: "उस समय की विलासिता का व्यापार",
        funFact: "🟣 बैंगनी = बहुत महंगा शाही रंग - लुदिया समृद्ध थी!"
      },
      medium: {
        question: "पौलुस लुदिया से कहाँ मिला?",
        options: [
          "बाज़ार में",
          "नदी के किनारे प्रार्थना स्थल पर",
          "उसके घर में",
          "आराधनालय में"
        ],
        hint: "बाहरी प्रार्थना स्थल",
        funFact: "🏞️ फिलिप्पी में आराधनालय नहीं था - परंपरा के अनुसार पानी के किनारे प्रार्थना!"
      },
      hard: {
        question: "लुदिया का धर्मांतरण परमेश्वर के कार्य के बारे में क्या प्रकट करता है?",
        options: [
          "वह प्रवृत्त थी",
          "परमेश्वर वचन प्राप्त करने के लिए तैयार हृदय खोलता है",
          "यह संयोग था",
          "पौलुस प्रेरक था"
        ],
        hint: "धर्मांतरण में परमेश्वर के कार्य के बारे में",
        funFact: "💝 'प्रभु ने उसका हृदय खोला' - परमेश्वर आत्माओं को तैयार और खोलता है!"
      }
    },

    75: {
      name: "फिलिप्पी में कारावास",
      challenge: "आधी रात को पौलुस और सीलास प्रार्थना करते और परमेश्वर की स्तुति करते थे...",
      easy: {
        question: "पौलुस और सीलास को क्यों कैद किया गया?",
        options: [
          "चोरी",
          "दुष्टात्मा निकालकर सार्वजनिक व्यवस्था बिगाड़ी",
          "निंदा",
          "दंगा"
        ],
        hint: "भविष्यवाणी करने वाली दासी की चंगाई",
        funFact: "💸 आत्माओं को मुक्त करने की शोषकों को कीमत चुकानी पड़ती है - आर्थिक उत्पीड़न!"
      },
      medium: {
        question: "पौलुस और सीलास ने जेल में क्या किया?",
        options: [
          "शिकायत की",
          "प्रार्थना और स्तुति की",
          "बचाव की तैयारी की",
          "सो गए"
        ],
        hint: "जंजीरों के बावजूद स्तुति",
        funFact: "🎵 आधी रात जेल में स्तुति - प्रभावशाली अटल विश्वास!"
      },
      hard: {
        question: "उनके दृष्टिकोण ने स्थिति को कैसे बदल दिया?",
        options: [
          "कोई प्रभाव नहीं पड़ा",
          "भूकंप के बाद जेलर का धर्मांतरण",
          "जेलर को चिढ़ा दिया",
          "उन्हें पागल बना दिया"
        ],
        hint: "उदाहरण द्वारा शक्तिशाली गवाही",
        funFact: "🌍 भूकंप + गवाही = जेलर और उसके परिवार का धर्मांतरण!"
      }
    },

    76: {
      name: "एथेंस में: एरियुपगुस",
      challenge: "जिसे तुम बिना जाने पूजते हो, उसी की मैं तुम्हें घोषणा करता हूँ...",
      easy: {
        question: "पौलुस ने एथेंस में किस वेदी का उल्लेख किया?",
        options: [
          "ज़्यूस देवता को",
          "अज्ञात देवता को",
          "अपोलो को",
          "एथेना को"
        ],
        hint: "प्रस्थान बिंदु बनने वाला रहस्यमय शिलालेख",
        funFact: "🏛️ 'अज्ञात देवता को' - ग्रीक दर्शन के साथ शानदार संपर्क बिंदु!"
      },
      medium: {
        question: "पौलुस ने एथेंस में किसके सामने प्रचार किया?",
        options: [
          "सामान्य भीड़",
          "एरियुपगुस के एपिकुरियन और स्टोइक दार्शनिक",
          "मंदिर के पुजारी",
          "रोमी सम्राट"
        ],
        hint: "ग्रीक बौद्धिक अभिजात वर्ग",
        funFact: "🧠 एरियुपगुस = प्राचीन हार्वर्ड - सर्वश्रेष्ठ विचारकों के सामने पौलुस!"
      },
      hard: {
        question: "एथेनियनों ने पुनरुत्थान पर क्या प्रतिक्रिया दी?",
        options: [
          "सर्वसम्मति से स्वीकृति",
          "विभाजन: कुछ ने उपहास किया, कुछ ने रुचि दिखाई",
          "सामान्य क्रोध",
          "पूर्ण उदासीनता"
        ],
        hint: "इस रहस्य पर बुद्धिजीवियों की विशिष्ट प्रतिक्रिया",
        funFact: "🤔 पुनरुत्थान = घमंडी मानव बुद्धि के लिए ठोकर का पत्थर!"
      }
    },

    77: {
      name: "कुरिन्थुस: तम्बू बनाने वाला पौलुस",
      challenge: "वह उनके साथ रहा और काम किया, क्योंकि तम्बू बनाना पेशा था...",
      easy: {
        question: "पौलुस ने जीविका के लिए क्या पेशा किया?",
        options: [
          "मछुआरा",
          "तम्बू बनाना",
          "लेखक",
          "व्यापारी"
        ],
        hint: "उसका सीखा हुआ हस्तशिल्प",
        funFact: "⛺ पौलुस: प्रेरित·कारीगर - मसीहियों के बीच हस्तशिल्प की गरिमा!"
      },
      medium: {
        question: "पौलुस कुरिन्थुस में किसके घर में ठहरा?",
        options: [
          "सराय",
          "अक्विला और प्रिस्किल्ला के घर",
          "राज्यपाल के घर",
          "आराधनालय"
        ],
        hint: "उसके जैसे तम्बू बनाने वाला दंपत्ति",
        funFact: "👫 अक्विला और प्रिस्किल्ला: अनुकरणीय मिशनरी दंपत्ति - मसीही आतिथ्य!"
      },
      hard: {
        question: "पौलुस ने अपने हाथों से क्यों काम किया?",
        options: [
          "केवल आर्थिक आवश्यकता के लिए",
          "बोझ न बनने और गवाही को सुनिश्चित करने के लिए",
          "पारिवारिक परंपरा के लिए",
          "क्योंकि वह पेशे को पसंद करता था"
        ],
        hint: "स्वतंत्रता और विश्वसनीयता के बारे में",
        funFact: "💼 आर्थिक स्वतंत्रता = वाक् स्वतंत्रता - पौलुस किसी पर निर्भर नहीं था!"
      }
    },

    78: {
      name: "इफिसुस में दंगा",
      challenge: "इफिसियों की अरतिमिस महान है!",
      easy: {
        question: "इफिसुस में पौलुस के विरुद्ध दंगा किसने उकसाया?",
        options: [
          "रोमी अधिकारी",
          "चाँदी का कारीगर देमेत्रियुस और शिल्पकार",
          "दार्शनिक",
          "यहूदी पुजारी"
        ],
        hint: "अरतिमिस का मंदिर बनाने वाले",
        funFact: "🏛️ इतिहास की पहली हड़ताल: सुसमाचार मूर्तिपूजा की अर्थव्यवस्था को धमकाता है!"
      },
      medium: {
        question: "पौलुस ने इफिसुस में कितने समय तक शिक्षा दी?",
        options: [
          "6 महीने",
          "1 साल",
          "2 साल",
          "3 साल"
        ],
        hint: "उसका सबसे लंबा मिशनरी प्रवास",
        funFact: "📅 3 साल की गहन शिक्षा - इफिसुस एक महत्वपूर्ण मिशनरी केंद्र बन गया!"
      },
      hard: {
        question: "यह दंगा सुसमाचार के सामाजिक प्रभाव के बारे में क्या प्रकट करता है?",
        options: [
          "सुसमाचार कुछ नहीं बदलता",
          "यह आर्थिक और सामाजिक संरचनाओं को बदलता है",
          "केवल धर्म से संबंधित है",
          "संघर्ष से बचता है"
        ],
        hint: "गहन सामाजिक परिवर्तन के बारे में",
        funFact: "💰 जब सुसमाचार आगे बढ़ता है, तो मूर्तियाँ बाज़ार खो देती हैं - आर्थिक प्रभाव!"
      }
    }
  }
};

export default chapter6Translations;
